import {ClsConfig} from '../../../util/cls-config';
import {GenericoService} from '../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {ClsUtil} from '../../../util/cls-util';
import {Workbook} from 'igniteui-angular-excel';
import {
  ClsPeticionRegistraActualizaCostoHorario,
  ClsPeticionUnCostoHorario,
  ClsRespuestaUnCostoHorario
} from '../../../core/models/peticiones/cls-pr-costo-horarios';

import { IgxGridComponent } from '@infragistics/igniteui-angular/grids/grid';
import {ClsObjExplosionDeInsumos} from '../menu-presupuesto/cls-obj-explosion-de-insumos';
import {
  ClsPeticionCH,
  ClsPeticionConsultarGralsCatalogos
} from '../../../core/models/peticiones/catalogos/cls-pr-catalogos';
import {EnumParaPpto} from '../../../core/models/enum/enum-parametros';
import {EnumTipoParametro} from '../../../core/models/enum/enum-tipo-parametro';
import {VtnGenericaComponent} from '../../../componentes/util/ventanas/vtn-generica/vtn-generica.component';
import {CostoHorarioComponent} from '../../../componentes/01-presupuesto/costo-horario/costo-horario.component';
import {ComponenteHostDirective} from '../../../componentes/00-contenedores/docker-manager/dock-slot.component';
import {ClsRespuestaPresupuestos} from '../../../core/models/peticiones/cls-pr-presupuestos';
import {SocketService} from '../../../core/services/socket.service';
import {EnumSocket} from '../../../core/models/enum/enum-socket';
import {
  ClsCostoHorarios, ClsGenerarCHBase64,
  ClsLsJsonCostosHorariosMO,
  ClsLsJsonCostosHorariosOC
} from "../../../core/models/cls-costo-horarios";
import {ClsCatalogosExpIns, ClsCatalogosExpIns2} from "../../../core/models/cls-catalogo-general";
import {ClsListaArchivos} from "../../../core/models/cls-storage";
import {ClsDetalleMatrizInsumos} from "../../../core/models/cls-matriz";
import {ClsErrores} from "../../../core/models/cls-errores";
import {ClsOpcionesReportes} from "../../../core/models/cls-reportes";
import {inject} from "@angular/core";
import {ExcelUtility} from "../../../util/excel-utility";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

export class ClsObjCostoHorario extends ClsConfig {
  public mLCostoHorarios: ClsCostoHorarios[] = [];
  private offset: number;
  public mapCodigoUnicos: Map<string, ClsCatalogosExpIns> = new Map<string, ClsCatalogosExpIns>();
  public mMaximoOc = 3;
  public mMaximoMo = 4;
  // propiedades
  private _MINDICEHOJACAMPOSGENERALES: number;
  private _MINDICEHOJADATOS: number;
  private _MINDICEHOJACALCULO: number;
  private _MINDICEHOJASOLOACTIVO: number;

  get IndiceHojaCamposGenerales(): number {
    return this._MINDICEHOJACAMPOSGENERALES;
  }

  set IndiceHojaCamposGenerales(value: number) {
    this._MINDICEHOJACAMPOSGENERALES = value;
  }

  get IndiceHojaDatos(): number {
    return this._MINDICEHOJADATOS;
  }

  set IndiceHojaDatos(value: number) {
    this._MINDICEHOJADATOS = value;
  }

  get IndiceHojaCalculo(): number {
    return this._MINDICEHOJACALCULO;
  }

  set IndiceHojaCalculo(value: number) {
    this._MINDICEHOJACALCULO = value;
  }

  get IndiceHojaSoloActivo(): number {
    return this._MINDICEHOJASOLOACTIVO;
  }

  set IndiceHojaSoloActivo(value: number) {
    this._MINDICEHOJASOLOACTIVO = value;
  }

  // OBJ
  public mObjGenerico: ClsObjGenerico;

  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  constructor() {
    super();
  }

  public async inicializarValidarDatosSubirArchivoLocal(file: File, prefix: string): Promise<ClsListaArchivos> {
    try {
      await this.validarHojasCHSubirArchivoLocal(file);
      return await ClsUtil.inicializarDatosSubirArchivoLocal(file, prefix);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarSeleccionCodigo(expIns: ClsCatalogosExpIns, codigo: string): boolean {
    try {
      if (expIns.EsPorcentaje) {
        throw new Error('MENSAJES.ALERT.CH_TIPO_ES_PORCENTAJE');
      }
      if (expIns.Nivel > 0) {
        throw new Error('MENSAJES.ALERT.CH_TIPO_NIVEL_MAYOR_0');
      }
      if (expIns.Codigo === codigo) {
        throw new Error(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CH_CODIGO_IGUAL').replace('{0}', codigo));
      }
      return true;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarOperacionOtrosConsumos(data: any[], expIns: ClsCatalogosExpIns, codigo: string, operacion: boolean): boolean {
    try {
      if (expIns.EsPorcentaje) {
        throw new Error('MENSAJES.ALERT.CH_TIPO_ES_PORCENTAJE');
      }
      if (operacion) {
        if (expIns.Tipo !== 2) {
          throw new Error('MENSAJES.ALERT.CH_TIPO_DIFERENTE_2');
        }
      }
      if (expIns.Codigo === codigo) {
        throw new Error(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CH_CODIGO_IGUAL').replace('{0}', codigo));
      }
      const existe: number = data.findIndex(value => value.Codigo === expIns.Codigo);
      if (existe !== -1) {
        throw new Error('MENSAJES.GRALS.EXISTE_CODIGO_EXP');
      }
      return true;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public generarMensajeErrorCFERVACostoHorario(mapErrores: Map<string, string>, mensaje: string): string {
    let mensajeError = '';

    if (mapErrores.size > 0) {
      let msj = '';
      mapErrores.forEach((value, key) => {
        msj += `${key}: ${value}<br>`;
      });
      mensajeError = mensaje.replace('{0}', `<br> ${msj}`);
    }
    return mensajeError;
  }

  public validarCFERVACostoHorarioParticipenAsiMismo(): Map<string, string> {
    const mapErrores: Map<string, string> = new Map<string, string>();

    const claves = ['cargofijo', 'espera', 'reserva', 'valoradquisicion'] as const;
    const traducciones: Record<string, string> = {
      cargofijo: 'MENSAJES.GRALS.CHCARGOFIJOACTIVO',
      espera: 'MENSAJES.GRALS.CHESPERA',
      reserva: 'MENSAJES.GRALS.CHRESERVA',
      valoradquisicion: 'MENSAJES.GRALS.CHVALORADQ',
    };

    const datos = claves.map(k => ({
      key: k,
      data: this.mapCodigoUnicos.get(k)
    }));

    for (let i = 0; i < datos.length; i++) {
      const actual = datos[i].data;
      let seEncontro = false;
      if (ClsUtil.esNulo(actual) || actual.IdCatalogo === BigInt(0)) continue;

      for (let j = 0; j < datos.length; j++) {
        if (i === j) continue; // No comparar consigo mismo
        const otro = datos[j].data;
        if (!ClsUtil.esNulo(otro) && otro.IdCatalogo === actual.IdCatalogo) {
          mapErrores.set(
            this.mObjGenerico.getTranslationsSubject(traducciones[datos[j].key]),
            actual.Codigo
          );
          seEncontro = true;
        }
      }
      if (seEncontro) {
        return mapErrores; // 🚀 Salida anticipada
      }
    }

    return mapErrores;
  }

  public validarCFERVACostoHorario(arrayCH: ClsCostoHorarios[], idCH: bigint): Map<string, string> {
    const mapErrores = new Map<string, string>();

    const catalogosConfig = [
      {key: 'cargofijo', prop: 'IdCatalogoCF', msg: 'MENSAJES.GRALS.CHCARGOFIJOACTIVO'},
      {key: 'espera', prop: 'IdCatalogoE', msg: 'MENSAJES.GRALS.CHESPERA'},
      {key: 'reserva', prop: 'IdCatalogoR', msg: 'MENSAJES.GRALS.CHRESERVA'},
      {key: 'valoradquisicion', prop: 'IdCatalogoVa', msg: 'MENSAJES.GRALS.CHVALORADQ'},
    ];

    const esValido = (expIns: ClsCatalogosExpIns) =>
      !ClsUtil.esNulo(expIns) && expIns.IdCatalogo !== BigInt(0);

    for (const {key, prop, msg} of catalogosConfig) {
      const expIns = this.mapCodigoUnicos.get(key);
      if (esValido(expIns)) {
        const existe = arrayCH.findIndex(value => {
          return value[prop] === expIns.IdCatalogo && value.IdCatalogoCostoHorario !== idCH
        });
        if (existe !== -1) {
          mapErrores.set(this.mObjGenerico.getTranslationsSubject(msg), expIns.Codigo);
        }
      }
    }

    return mapErrores;
  }

  public async subirDocumentoDefaultCH(idPpto: bigint): Promise<ClsListaArchivos> {
    try {
      const nomDocCH = this.gNomDocCHDefault; // obtener nombre doc ch default
      // descargar doc default del bocket neodata
      const docSelec = await ClsUtil.descargarArchivoCargarVnt('', this.gPrefixMoneda1, nomDocCH, this.gNomBocketCH, this.gNomPrefixNeodata, this.gNomPrefixPptoCH, this.mObjGenerico);
      // subir doc default al bocket del proyecto
      await this.mObjGenerico.subirArchivosStorage(EnumTipoParametro.Presupuesto, this.gNomBocketPpto, `${this.gNomPrefixPptoCH}/${nomDocCH}`, docSelec.ContenidoBase64, idPpto, docSelec.TipoArchivo);
      // actualizamos el parametro CHNombreLibroCH
      await this.mObjGenerico.registraActualizaNParametros(idPpto, EnumTipoParametro.Presupuesto, [{Parametro: EnumParaPpto.CHNOMBRELIBROCH, Valor: nomDocCH}]);

      return docSelec;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async validarDocumentoCHDescarga(nomDocCH: string, idPpto: bigint): Promise<ClsListaArchivos> {
    try {
      let docSelec: ClsListaArchivos;
      if (ClsUtil.esNulo(nomDocCH)) {
        docSelec = await this.subirDocumentoDefaultCH(idPpto);
      } else {
        // descargamos el doc que tiene config el proyecto, en caso de regresar undefined
        // posiblemente no se subio o X razon que no existe el doc y se procede a descargar el doc default
        docSelec = await ClsUtil.descargarArchivoCargarVnt(idPpto.toString(), this.gPrefixMoneda1, nomDocCH, this.gNomBocketPpto, this.gNomPrefixNeodata, this.gNomPrefixPptoCH, this.mObjGenerico);
        if (ClsUtil.esNulo(docSelec) || docSelec?.ContenidoArchivoFile.size === 0) {
          await this.validarDocumentoCHDescarga('', idPpto);
        }
      }
      return docSelec;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async obtenerValidarConsultasCH() {
  //   try {
  //     let actualizado: boolean;
  //     // validar si obj costoHorariosBocket esta vacio ir a obtener la inf del bocket
  //     if (!this.infPpto.objHayCHMaestro) {
  //       this.infPpto.objCHMaestroBocket = await this.obtenerTodosLosCHBocket();
  //       return;
  //     }
  //     // si obj costoHorariosBocket tiene inf, validar si la fecha esta actualizada, para no ir a obtener el json de CH del bocket
  //     actualizado = await this.validaFechaConsultasBocketCH();
  //     if (!actualizado) {
  //       this.infPpto.objCHMaestroBocket = await this.obtenerTodosLosCHBocket();
  //     }
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }

  /**
   * Metodo para validar las hojas necesarias para realizar los calculos necesarios
   * @param file
   */
  public async validarHojasCHSubirArchivoLocal(file: File) {
    try {
      const libro: any = await ExcelUtility.loadXLSX(file);
      this.IndiceHojaCamposGenerales = ExcelUtility.ubicaHojaXLSX(libro, 'N_Campos Generales');
      this.IndiceHojaDatos = ExcelUtility.ubicaHojaXLSX(libro, 'N_Campos Especificos');
      this.IndiceHojaCalculo = ExcelUtility.ubicaHojaXLSX(libro, 'Estandar');
      this.IndiceHojaSoloActivo = ExcelUtility.ubicaHojaXLSX(libro, 'SoloActivo%');

      this.validarIndexHojasCH(this.IndiceHojaCamposGenerales, this.IndiceHojaDatos, this.IndiceHojaCalculo);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async validarSetIndexHojasCHDefault(file: File) {
    try {
      const libro: Workbook = await ExcelUtility.load(file);
      this.IndiceHojaCamposGenerales = ClsUtil.ubicaHoja(libro, 'N_Campos Generales');
      this.IndiceHojaDatos = ClsUtil.ubicaHoja(libro, 'N_Campos Especificos');
      this.IndiceHojaCalculo = ClsUtil.ubicaHoja(libro, 'Estandar');
      this.IndiceHojaSoloActivo = ClsUtil.ubicaHoja(libro, 'SoloActivo%');

      this.validarIndexHojasCH(this.IndiceHojaCamposGenerales, this.IndiceHojaDatos, this.IndiceHojaCalculo);
      return libro;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private validarIndexHojasCH(indiceHojaCamposGenerales: number, indiceHojaDatos: number, indiceHojaCalculo: number) {
    try {
      if (indiceHojaCamposGenerales === -1) {
        throw new Error('MENSAJES.ALERT.LIBRO_CAMPOS_GRALS');
      }
      if (indiceHojaDatos === -1) {
        throw new Error('MENSAJES.ALERT.CH_LIRBO_CAMPOS_ESPECIFICOS');
      }
      if (indiceHojaCalculo === -1) {
        throw new Error('MENSAJES.ALERT.CH_LIBRO_CAMPOS_ESTANDAR');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public crearObjMatrizACatalogo(grid: IgxGridComponent, objExpInsumos: ClsObjExplosionDeInsumos, mapCatalogo: Map<string, ClsCatalogosExpIns>): ClsCatalogosExpIns[] {
    const arrayExp: ClsCatalogosExpIns[] = [];
    grid.data.forEach((value: ClsDetalleMatrizInsumos) => {
      let exp: ClsCatalogosExpIns = mapCatalogo.get(value.Codigo);
      if (ClsUtil.esNulo(exp)) {
        exp = objExpInsumos.inicializarAsignarRegistro(undefined);
      }
      exp.Participa = true;
      exp.Codigo = value.Codigo;
      exp.Tipo = value.TipoInsumo;
      exp.DescripcionLarga = value.DescripcionLarga;
      exp.Descripcion = value.Descripcion;
      exp.Unidad = value.Unidad;
      exp.CostoMoneda1 = ClsUtil.esNulo(value.CostoMoneda1) ? 0 : value.CostoMoneda1;
      exp.CostoMoneda2 = ClsUtil.esNulo(value.CostoMoneda2) ? 0 : value.CostoMoneda2;
      arrayExp.push(exp);
    });
    return arrayExp;
  }

  public async guardarExpIns(arrayExpIns: ClsCatalogosExpIns[], allExpInsAntes: ClsCatalogosExpIns[], objExpInsumos: ClsObjExplosionDeInsumos, socket: SocketService): Promise<ClsCatalogosExpIns[]> {
    let newArrayExpIns: ClsCatalogosExpIns[] = [];
    try {
      // verificar si cambio algo el registro
      arrayExpIns.forEach(newValor => {
        const oldValue: ClsCatalogosExpIns = allExpInsAntes.find(ins => ins.Codigo.toUpperCase() === newValor.Codigo.toUpperCase());
        if (objExpInsumos.compararSiCambioAnyCampos(newValor, oldValue)) {
          newArrayExpIns.push(newValor);
        }
      });
      if (newArrayExpIns.length > 0) {
        // creamos OBJ para mandar al servicio
        const objCatalogo: ClsCatalogosExpIns2[] = objExpInsumos.inicializarRegistroServicio(newArrayExpIns, true);
        // mandamos peticion con el OBJ adecuado
        const respuesta: any = await objExpInsumos.registraActualizaRegistro(objCatalogo);
        // iteramos la respuesta para ir asignando los idcat para los EQs
        const key: string[] = Object.keys(respuesta);
        key.forEach(value => {
          arrayExpIns.find(value1 => value1.Codigo === value).IdCatalogo = ClsUtil.bigintX(respuesta[value]);
        });
        // actualizamos la lista del catalogo localmente
        objExpInsumos.agregarModificarBorrarListaExpIns(arrayExpIns, false);
        socket.replicate({Type: EnumSocket.ModificarExpIns, Data: arrayExpIns});
      }
      return arrayExpIns;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public generarObjCatalogoAlGuardarTodoCH(expIns: ClsCatalogosExpIns, mapCatalogo: Map<string, ClsCatalogosExpIns>, des: string, unidad: string, costo: number, esMoneda1: boolean, esEQ: boolean = false): ClsCatalogosExpIns {
    let expInsCat: ClsCatalogosExpIns;
    // se busca en el mapa en caso de que el codigo este en los grids y sea nuevo
    // y asi obtener su id
    expInsCat = mapCatalogo.get(expIns.Codigo);
    // si es null no existe, entonces no se ocupo en los grids
    if (!ClsUtil.esNulo(expInsCat)) {
      expIns.IdCatalogo = expInsCat.IdCatalogo;
    }
    if (esEQ) {
      expIns.Participa = !expIns.Participa ? !esEQ : expIns.Participa;
    } else {
      expIns.Participa = true;
    }
    // expIns.Participa = !esEQ;
    expIns.DescripcionLarga = des;
    expIns.Unidad = unidad.toUpperCase();
    if (esMoneda1) {
      expIns.CostoMoneda1 = ClsUtil.numberX(costo, true);
    } else {
      expIns.CostoMoneda2 = ClsUtil.numberX(costo, true);
    }

    return expIns;
  }

  // public async descargarArchivoStorage(doc: ClsListaArchivos): Promise<ClsListaArchivos> {
  //   try {
  //     // descargar archivo storage
  //     const respArchivo: ClsRespuestaDescargaArchivosStorage = await this.mObjGenerico.descargarArchivoStorage(this.nomBocketCH, doc.NombreArchivo);
  //     // convertir base 64 a blob
  //     doc.ContenidoBase64 = respArchivo.ContenidoArchivo;
  //     const blob = ExcelUtility.convertBase64StringToBlob(respArchivo.ContenidoArchivo, doc.TipoArchivo);
  //     // convertir blob a File
  //     doc.ContenidoArchivoFile = ClsUtil.convertBlobToFile(blob, doc.Documento + doc.Extension);
  //     doc.Workbook = await ExcelUtility.load(doc.ContenidoArchivoFile);
  //     return doc;
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }

  public async obtenerUnCostoHorario(idCatalogoCH: bigint): Promise<ClsCostoHorarios> {
    let respuesta: ClsCostoHorarios;
    const objPeticion: ClsPeticionUnCostoHorario = new ClsPeticionUnCostoHorario();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdCatalogoCostoHorario = idCatalogoCH;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ConsultarUnCostosHorarios2021');
      // modo offline
      if (!respuesta) {
        return undefined;
      }
      const resp: ClsRespuestaUnCostoHorario = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp.LsCatalogo?.[0]; // devuelve el primero o undefined
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async registraActualizaCostoHorario(costoHorario: ClsCostoHorarios[]) {
    const objPeticion: ClsPeticionRegistraActualizaCostoHorario = new ClsPeticionRegistraActualizaCostoHorario();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
    objPeticion.Catalogo = costoHorario;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'CostosHorariosRegistraActualiza2021');
      // modo offline
      if (!resp) {
        return;
      }
      const resp2: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (resp2?.ErrorDescripcion !== '') {
        throw new Error(resp.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerTodosLosCH(offset: number): Promise<ClsCostoHorarios[]> {
    this.offset = offset;
    const objPeticion: ClsPeticionConsultarGralsCatalogos = new ClsPeticionConsultarGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.Limit = this.gLimiteRegistro;
    objPeticion.Offset = this.offset * this.gLimiteRegistro; // se incrimenta en base el limite
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ConsultarCostosHorarios2021');
      // modo offline
      if (!resp) {
        return [];
      }
      const costosHorarios: ClsRespuestaUnCostoHorario = ClsUtil.parseJSONBig(resp);
      if (costosHorarios?.Errores?.ErrorDescripcion !== '') {
        throw new Error(costosHorarios.Errores.ErrorDescripcion);
      }
      this.mLCostoHorarios = this.mLCostoHorarios.concat(costosHorarios.LsCatalogo);
      // si length es igual a limite(30,000) posiblemente hay mas datos para obtener
      // si no es es igual, regresar resultado
      if (costosHorarios.LsCatalogo.length === this.gLimiteRegistro) {
        this.offset++;
        await this.obtenerTodosLosCH(this.offset);
      } else {
        return this.mLCostoHorarios;
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async validaFechaConsultasBocketCH(): Promise<boolean> {
  //   let respuesta: boolean;
  //   const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
  //   objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'validaFechaConsultasCH')
  //     .then(async (resp: any) => {
  //       const valida: ClsValidaFechasConsultas = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (valida.Errores.ErrorDescripcion !== '') {
  //           throw new Error(valida.Errores.ErrorDescripcion);
  //         } else {
  //           return valida.Estatus;
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }

  // public async obtenerTodosLosCHBocket(): Promise<ClsCostoHorarios[]> {
  //   let respuesta: ClsCostoHorarios[];
  //   const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneCostosHorariosStorage')
  //     .then(async (resp: any) => {
  //       const ch: ClsCostoHorarios[] = [];
  //       const result: ClsCostosHorariosStorageZip = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (result.Errores.ErrorDescripcion !== '') {
  //           throw new Error(result.Errores.ErrorDescripcion);
  //         } else {
  //           const costosHorarios: string = await ClsUtil.descomprimirArchivoBase64(result.CostosHorarios, 'CostosHorarios.txt');
  //           // this.infPpto.objHayCHMaestro = true;
  //           if (ClsUtil.esNulo(costosHorarios)) {
  //             return ch;
  //           }
  //           const objChS: string[] = ClsUtil.splitEnter(costosHorarios);
  //           const costosHorariosMO: string = await ClsUtil.descomprimirArchivoBase64(result.CostosHorariosMO, 'CostosHorariosMO.txt');
  //           const arrayMO: ClsLsJsonCostosHorariosMO[] = [];
  //           if (!ClsUtil.esNulo(costosHorariosMO)) {
  //             const objChMO: string[] = ClsUtil.splitEnter(costosHorariosMO);
  //             objChMO.forEach(value => {
  //               const filas: string[] = ClsUtil.splitTabs(value);
  //               arrayMO.push({IdCatalogoCostoHorario: ClsUtil.bigintX(filas[0]), IdCatalogoMO: ClsUtil.bigintX(filas[1]), Renglon: ClsUtil.numberX(filas[2]), Volumen: ClsUtil.numberX(filas[3])});
  //             });
  //           }
  //           const costosHorariosOC: string = await ClsUtil.descomprimirArchivoBase64(result.CostosHorariosOC, 'CostosHorariosOC.txt');
  //           const arrayOC: ClsLsJsonCostosHorariosOC[] = [];
  //           if (!ClsUtil.esNulo(costosHorariosOC)) {
  //             const objChOC: string[] = ClsUtil.splitEnter(costosHorariosOC);
  //             objChOC.forEach(value => {
  //               const filas: string[] = ClsUtil.splitTabs(value);
  //               arrayOC.push({IdCatalogoCostoHorario: ClsUtil.bigintX(filas[0]), IdCatalogoOC: ClsUtil.bigintX(filas[1]), Renglon: ClsUtil.numberX(filas[2]), Volumen: ClsUtil.numberX(filas[3])});
  //             });
  //           }
  //           objChS.forEach(value => {
  //             const objCh: ClsCostoHorarios = new ClsCostoHorarios();
  //             const filas: string[] = ClsUtil.splitTabs(value);
  //             objCh.IdCatalogoCostoHorario = ClsUtil.bigintX(filas[0]);
  //             objCh.CalculoDetallado = Boolean(ClsUtil.numberX(filas[1]));
  //             objCh.CantidadCombustible = ClsUtil.numberX(filas[2]);
  //             objCh.CantidadLubricante = ClsUtil.numberX(filas[3]);
  //             objCh.Capacidad = ClsUtil.cadenaX(filas[4]);
  //             objCh.Ccarter = Number(filas[5]);
  //             objCh.Disponibilidad = ClsUtil.cadenaX(filas[6]);
  //             objCh.Faceite = ClsUtil.numberX(filas[7]);
  //             objCh.Factcomb = ClsUtil.numberX(filas[8]);
  //             objCh.FactFuentes = ClsUtil.numberX(filas[9]);
  //             objCh.Foper = ClsUtil.numberX(filas[10]);
  //             objCh.Ha = ClsUtil.numberX(filas[11]);
  //             objCh.Hllantas = ClsUtil.numberX(filas[12]);
  //             objCh.Horasc = ClsUtil.numberX(filas[13]);
  //             objCh.HPiezas = ClsUtil.numberX(filas[14]);
  //             objCh.IdCatalogoAcei = ClsUtil.bigintX(filas[15]);
  //             objCh.IdCatalogoCF = ClsUtil.bigintX(filas[16]);
  //             objCh.IdCatalogoComb = ClsUtil.bigintX(filas[17]);
  //             objCh.IdCatalogoE = ClsUtil.bigintX(filas[18]);
  //             objCh.IdCatalogoLla = ClsUtil.bigintX(filas[19]);
  //             objCh.IdCatalogoOtrasFuentes = ClsUtil.bigintX(filas[20]);
  //             objCh.IdCatalogoPza = ClsUtil.bigintX(filas[21]);
  //             objCh.IdCatalogoR = ClsUtil.bigintX(filas[22]);
  //             objCh.IdCatalogoVa = ClsUtil.bigintX(filas[23]);
  //             objCh.Marca = ClsUtil.cadenaX(filas[24]);
  //             objCh.Modelo = ClsUtil.cadenaX(filas[25]);
  //             objCh.NumSerie = ClsUtil.cadenaX(filas[26]);
  //             objCh.Potencia = ClsUtil.numberX(filas[27]);
  //             objCh.Propietario = ClsUtil.cadenaX(filas[28]);
  //             objCh.ProponerCodigos = Boolean(ClsUtil.numberX(filas[29]));
  //             objCh.Q = ClsUtil.numberX(filas[30]);
  //             objCh.S = ClsUtil.numberX(filas[31]);
  //             objCh.TipoCombustible = ClsUtil.numberX(filas[32]);
  //             objCh.Ubicacion = ClsUtil.cadenaX(filas[33]);
  //             objCh.UnidadPotencia = ClsUtil.cadenaX(filas[34]);
  //             objCh.ValorComercial = ClsUtil.numberX(filas[35]);
  //             objCh.Ve = ClsUtil.numberX(filas[36]);
  //             objCh.VidaUtil = ClsUtil.cadenaX(filas[37]);
  //             objCh.Vr = ClsUtil.numberX(filas[38]);
  //             objCh.TasaInteresMoneda1 = ClsUtil.numberX(filas[39]);
  //             objCh.TasaInteresMoneda2 = ClsUtil.numberX(filas[40]);
  //             objCh.LsCostosHorariosMO = arrayMO.length === 0 ? [] : arrayMO.filter(value1 => value1.IdCatalogoCostoHorario === objCh.IdCatalogoCostoHorario);
  //             objCh.LsCostosHorariosOC = arrayOC.length === 0 ? [] : arrayOC.filter(value1 => value1.IdCatalogoCostoHorario === objCh.IdCatalogoCostoHorario);
  //             ch.push(objCh);
  //           });
  //           return ch;
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }
  /**
   * Este metodo descomprime los costos horarios: ClsUtil.descomprimirArchivoBase64(respuesta.CostosHorarios, 'CostosHorarios.txt');
   * @param respuesta recibe la data completa para descomprimir CH, CHMO, CHOC
   */
  public async crearObjCostosHorarios(respuesta: ClsRespuestaPresupuestos): Promise<ClsCostoHorarios[]> {
    const ch: ClsCostoHorarios[] = [];
    try {
      const costosHorarios: string = await ClsUtil.descomprimirArchivoBase64(respuesta.CostosHorarios, 'CostosHorarios.txt');
      if (ClsUtil.esNulo(costosHorarios)) {
        return ch;
      }
      const objChS: string[] = ClsUtil.splitEnterNeo(costosHorarios);
      const costosHorariosMO: string = await ClsUtil.descomprimirArchivoBase64(respuesta.CostosHorariosMO, 'CostosHorariosMO.txt');
      const arrayMO: ClsLsJsonCostosHorariosMO[] = [];
      if (!ClsUtil.esNulo(costosHorariosMO)) {
        const objChMO: string[] = ClsUtil.splitEnterNeo(costosHorariosMO);
        objChMO.forEach(value => {
          const filas: string[] = ClsUtil.splitTabsNeo(value);
          arrayMO.push({
            IdCatalogoCostoHorario: ClsUtil.bigintX(filas[0]),
            IdCatalogoMO: ClsUtil.bigintX(filas[1]),
            Renglon: ClsUtil.numberX(filas[2]),
            Volumen: ClsUtil.numberX(filas[3])
          });
        });
      }
      const costosHorariosOC: string = await ClsUtil.descomprimirArchivoBase64(respuesta.CostosHorariosOC, 'CostosHorariosOC.txt');
      const arrayOC: ClsLsJsonCostosHorariosOC[] = [];
      if (!ClsUtil.esNulo(costosHorariosOC)) {
        const objChOC: string[] = ClsUtil.splitEnterNeo(costosHorariosOC);
        objChOC.forEach(value => {
          const filas: string[] = ClsUtil.splitTabsNeo(value);
          arrayOC.push({
            IdCatalogoCostoHorario: ClsUtil.bigintX(filas[0]),
            IdCatalogoOC: ClsUtil.bigintX(filas[1]),
            Renglon: ClsUtil.numberX(filas[2]),
            Volumen: ClsUtil.numberX(filas[3])
          });
        });
      }
      objChS.forEach(value => {
        const objCh: ClsCostoHorarios = new ClsCostoHorarios();
        const filas: string[] = ClsUtil.splitTabsNeo(value);
        objCh.IdCatalogoCostoHorario = ClsUtil.bigintX(filas[0]);
        objCh.CalculoDetallado = Boolean(ClsUtil.numberX(filas[1]));
        objCh.CantidadCombustible = ClsUtil.numberX(filas[2]);
        objCh.CantidadLubricante = ClsUtil.numberX(filas[3]);
        objCh.Capacidad = ClsUtil.cadenaX(filas[4]);
        objCh.Ccarter = Number(filas[5]);
        objCh.Disponibilidad = ClsUtil.cadenaX(filas[6]);
        objCh.Faceite = ClsUtil.numberX(filas[7]);
        objCh.Factcomb = ClsUtil.numberX(filas[8]);
        objCh.FactFuentes = ClsUtil.numberX(filas[9]);
        objCh.Foper = ClsUtil.numberX(filas[10]);
        objCh.Ha = ClsUtil.numberX(filas[11]);
        objCh.Hllantas = ClsUtil.numberX(filas[12]);
        objCh.Horasc = ClsUtil.numberX(filas[13]);
        objCh.HPiezas = ClsUtil.numberX(filas[14]);
        objCh.IdCatalogoAcei = ClsUtil.bigintX(filas[15]);
        objCh.IdCatalogoCF = ClsUtil.bigintX(filas[16]);
        objCh.IdCatalogoComb = ClsUtil.bigintX(filas[17]);
        objCh.IdCatalogoE = ClsUtil.bigintX(filas[18]);
        objCh.IdCatalogoLla = ClsUtil.bigintX(filas[19]);
        objCh.IdCatalogoOtrasFuentes = ClsUtil.bigintX(filas[20]);
        objCh.IdCatalogoPza = ClsUtil.bigintX(filas[21]);
        objCh.IdCatalogoR = ClsUtil.bigintX(filas[22]);
        objCh.IdCatalogoVa = ClsUtil.bigintX(filas[23]);
        objCh.Marca = ClsUtil.cadenaX(filas[24]);
        objCh.Modelo = ClsUtil.cadenaX(filas[25]);
        objCh.NumSerie = ClsUtil.cadenaX(filas[26]);
        objCh.Potencia = ClsUtil.numberX(filas[27]);
        objCh.Propietario = ClsUtil.cadenaX(filas[28]);
        objCh.ProponerCodigos = Boolean(ClsUtil.numberX(filas[29]));
        objCh.Q = ClsUtil.numberX(filas[30]);
        objCh.S = ClsUtil.numberX(filas[31]);
        objCh.TipoCombustible = ClsUtil.numberX(filas[32]);
        objCh.Ubicacion = ClsUtil.cadenaX(filas[33]);
        objCh.UnidadPotencia = ClsUtil.cadenaX(filas[34]);
        objCh.ValorComercial = ClsUtil.numberX(filas[35]);
        objCh.Ve = ClsUtil.numberX(filas[36]);
        objCh.VidaUtil = ClsUtil.cadenaX(filas[37]);
        objCh.Vr = ClsUtil.numberX(filas[38]);
        objCh.TasaInteresMoneda1 = ClsUtil.numberX(filas[39]);
        objCh.TasaInteresMoneda2 = ClsUtil.numberX(filas[40]);
        objCh.LsCostosHorariosMO = arrayMO.length === 0 ? [] : arrayMO.filter(value1 => value1.IdCatalogoCostoHorario === objCh.IdCatalogoCostoHorario);
        objCh.LsCostosHorariosOC = arrayOC.length === 0 ? [] : arrayOC.filter(value1 => value1.IdCatalogoCostoHorario === objCh.IdCatalogoCostoHorario);
        ch.push(objCh);
      });
      return ch;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async generaReporteCostosHorarios(objOpciones: ClsOpcionesReportes): Promise<ClsGenerarCHBase64> {
    let respuesta: ClsGenerarCHBase64;
    const objPeticionCH: ClsPeticionCH = new ClsPeticionCH();
    objPeticionCH.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticionCH.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticionCH.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticionCH.Formato = objOpciones.Formato;
    objPeticionCH.ReporteCHBase64 = objOpciones.Base64String;
    objPeticionCH.TipoMoneda = objOpciones.TipoMoneda;
    objPeticionCH.OpcionEquipos = objOpciones.OpcionEquipos;
    objPeticionCH.ConDescripcionLarga = objOpciones.ConDescripcionLarga;
    objPeticionCH.EquipoInicial = objOpciones.RangoInicial;
    objPeticionCH.EquipoFinal = objOpciones.RangoFinal;
    objPeticionCH.LogoDep = ClsUtil.esNulo(objOpciones.Logo) ? '' : objOpciones.Logo;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunNET(objPeticionCH, 'RptCostosHorarios/GeneraReporteCostosHorarios');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp = ClsUtil.parseJSONBig(respuesta);
      if (resp?.errores && resp.errores.errorDescripcion) {
        throw new Error(resp.errores.errorDescripcion);
      }
      return resp;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async abrirVentanaCH(data: any, objExpInsumos: ClsObjExplosionDeInsumos, busquedaValid = true) {
    const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
    vtnGenerico.queVtnEstaAbierta = 'DetalleRegistro';
    const vtnCostoHorario: CostoHorarioComponent = vtnGenerico.crearComponente(CostoHorarioComponent);
    if (busquedaValid) {
      vtnCostoHorario.filaSeleccionado = objExpInsumos.buscarCodigoEnExpIns(data.Codigo);
      if (ClsUtil.esNulo(data.IdCatalogo)) {
        vtnCostoHorario.filaSeleccionado.IdCatalogo = ClsUtil.bigintX(data.IdCatalogoS);
      }
    } else {
      vtnCostoHorario.filaSeleccionado = data;
    }
    await vtnCostoHorario.open();
  }

  public async validarSiParticipaCHYCrearVtnGenerico(datos: any, tipo: number): Promise<VtnGenericaComponent> {
    try {
      if (datos.Nivel > 0 && ClsUtil.esNulo(tipo)) {
        throw new Error('MENSAJES.ALERT.NO_PUEDE_CAMBIAR_TIPO');
      }
      if (ClsUtil.participaEnCostoHorario(datos.IdCatalogo, this.infPpto)) {
        throw new Error('MENSAJES.ALERT.NO_PUEDE_CAMBIAR_TIPO');
      }
      if (ClsUtil.CFParticipaEnCostoHorario(datos.IdCatalogo, this.infPpto)) {
        throw new Error('MENSAJES.ALERT.NO_PUEDE_CAMBIAR_TIPO');
      }
      const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
      vtnGenerico.queVtnEstaAbierta = 'TipoEquipoHerramienta';

      return vtnGenerico;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public actualizarListaCH(ch: ClsCostoHorarios) {
    const allCH: ClsCostoHorarios[] = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CostoHorarios;
    const indexCH: number = allCH.findIndex(value => value.IdCatalogoCostoHorario === ch.IdCatalogoCostoHorario);
    (indexCH === -1) ? allCH.push(ch) : allCH[indexCH] = ch;
  }
}
